export default __webpack_public_path__ + "0064020d28172fd0344ebfad2bf88ac3.png";